import Tooltip from '@/components/Tooltip';
import { Text, Grid, useTheme } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const NarrativeValuatorTooltip = ({ children }: Props) => {
  const theme = useTheme();
  return (
    <Tooltip
      light
      title={
        <Grid paddingY="x1" paddingX="x1_5" maxWidth="260px">
          {children && (
            <Text textAlign="center" typography="tiny" color="spaceGray">
              {children}
            </Text>
          )}
        </Grid>
      }
    >
      <InformationSolid fill={theme.color.textSofter} />
    </Tooltip>
  );
};
